import { WorldEvent } from '../WorldRecords/worldrecords';
import { User } from '../../domains/app';

export interface AchievementsContainerState {
  listAchievements: Achievement[];
  page: number;
  pageSize: number;
  total: number;
  isFetching: boolean;
  search: string;
  activeAchievement?: Achievement;
  showAchievementDetails: boolean;
}

export interface Achievement {
  id?: string;
  male?: boolean;
  event?: WorldEvent;
  eventId: string;
  person?: User;
  personId: string;
  confirmedByPerson?: User;
  confirmedByPersonId?: string;
  condition?: string;
  levelOrResult: string;
  confirmed?: string | Date;
  end?: string | Date;
  achievedOrStart?: string | Date;
  status?: AchievementStatus;
  rankPercentage?: number;
}

export enum AchievementStatus {
  Pending = 0,
  Confirmed = 1,
  Declined = 2,
}
